import { render } from "./FormStepSubmitting.vue?vue&type=template&id=0cbde7ac"
import script from "./FormStepSubmitting.vue?vue&type=script&lang=js"
export * from "./FormStepSubmitting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__